import { omit } from "lodash";

import type { LeadsSearchRequestDto } from "app/pages/sales-intelligence/modules/leads-search/types";
import type {
    ILeadsSearchFiltersDto,
    LeadsSearchAllFiltersTypes,
} from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import { leadsFilterPanelValueToDto } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/leadsFilterDtoAdapters";
import { resolveLeadsFiltersDto } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/resolveLeadsFilterPanelValue";

import { createLeadsSearchRequestDto } from "../store/utils";

const COMPANIES_COUNT_PAGE = 1;
const COMPANIES_COUNT_PAGE_SIZE = 1;

/** Minimal companies search request for selected-criteria count previews. */
export const buildCompaniesSearchCountDto = (
    panelValue: Partial<LeadsSearchAllFiltersTypes>,
): LeadsSearchRequestDto => {
    const panelDto = leadsFilterPanelValueToDto(panelValue);
    const signalsFilters = panelDto.signalsFilters;
    const resolvedFilters = resolveLeadsFiltersDto(omit(panelDto, "signalsFilters") as Partial<ILeadsSearchFiltersDto>);
    const queryFilters = signalsFilters ? { ...resolvedFilters, signalsFilters } : resolvedFilters;

    return createLeadsSearchRequestDto({
        page: COMPANIES_COUNT_PAGE,
        pageSize: COMPANIES_COUNT_PAGE_SIZE,
        searchText: "",
        contactsSearchText: "",
        appsSearchText: "",
        queryFilters,
    });
};
